<template>
  <div class="page-landing" v-scroll-spy="scrollPos">

    <hotlink-section></hotlink-section>

    <about-section></about-section>

    <!-- <masonry-youtube @onItemsEnded="itemsEnded = true;" data-aos="fade-in" data-aos-once="true"></masonry-youtube> -->

    <div id="section-show" height="0" style="height:0;">
    </div>

    <!-- <show-section type="upcoming" full="false"></show-section>
    <show-section type="previous" full="false"></show-section> -->

    <!-- <newsletter-section></newsletter-section> -->

    <instagram-section id="photos-official" data-aos="fade-in" data-aos-once="true" @onItemClick="onDialogPhoto"></instagram-section>

    <sponsors-section></sponsors-section>

    <!-- <main-dialog
      :visible="dialogVisible"
      @onClose="onCloseDialog"
    /> -->

    <base-dialog
      :visible="dialogPhotoVisible"
      :no-footer="true"
      @onClose="onCloseDialogPhoto">
      <figure class="image">
        <img :src="(dialogPhoto.image && dialogPhoto.image.path ? dialogPhoto.image.path : (dialogPhoto.type === 'VIDEO' ? dialogPhoto.url2 : dialogPhoto.url))" alt="Image">
      </figure>
    </base-dialog>

    <vm-back-top :bottom="45" :right="25" :duration="1000" :timing="'ease'" v-if="false">
      <div class="top"><span></span></div>
    </vm-back-top>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'

import MasonryYoutube from '@/components/MasonryYoutube.vue'
import HotlinkSection from './HotlinkSection.vue'
import AboutSection from './AboutSection.vue'
import SponsorsSection from './SponsorsSection.vue'

import NewsletterSection from './NewsletterSection.vue'
import InstagramSection from './InstagramSection.vue'
import ContactSection from './ContactSection.vue'

import MainDialog from '@/components/MainDialog.vue'
import BaseDialog from '@/components/Dialog.vue'

export default {
  name: 'landing',
  components: {
    MasonryYoutube,
    HotlinkSection,
    AboutSection,
    NewsletterSection,
    InstagramSection,
    ContactSection,
    SponsorsSection,
    MainDialog,
    BaseDialog
  },
  data () {
    return {
      isDesktop: true,
      // itemsEnded: false,
      scrollPos: 0,
      dialogVisible: true,
      dialogPhotoVisible: false,
      dialogPhoto: {}
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    // console.log('created Landing.vue')
  },
  mounted () {
    // console.log('mounted Landing.vue')
    // window.GA('send', 'pageview')

    if (this.$route.query && this.$route.query.anchor) {
      console.log('automatic scroll to...: ' + this.$route.query.anchor)
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor)
      }.bind(this), 2000)
    }

    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    },

    onCloseDialog: function () {
      this.dialogVisible = false
    },

    onDialogPhoto: function (item) {
      this.dialogPhotoVisible = true
      this.$set(this, 'dialogPhoto', item || {})
    },

    onCloseDialogPhoto: function () {
      this.dialogPhotoVisible = false
      this.$set(this, 'dialogPhoto', {})
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-landing {

  .top {
    padding: 10px;
    background: $color-gray-mid;
    color: #fff;
    text-align: center;
    border-radius: 2px;
    transition: 1s linear;
    position: relative;
    width: 35px;
    height: 35px;

    span {
      position: absolute;
      top: 18px;
      left: 50%;
      width: 15px;
      height: 15px;
      margin-left: -7px;
      border-left: 1px solid $color-white;
      border-bottom: 1px solid $color-white;
      transform: rotate(135deg);
      animation: arrow-up-animate 3s infinite;
      box-sizing: border-box;
    }
    @keyframes arrow-up-animate {
      0% {
        transform: rotate(135deg) translate(0, 0);
      }
      30% {
        transform: rotate(135deg) translate(-10px, 10px);
      }
      80% {
        transform: rotate(135deg) translate(0, 0);
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Landing.vue?7f13f43c